import { render, staticRenderFns } from "./monitoringPests.vue?vue&type=template&id=6d876f96&"
import script from "./monitoringPests.vue?vue&type=script&lang=js&"
export * from "./monitoringPests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports